import type { ReactNode } from "react";
import { createContext, useContext } from "react";

export interface ChatRoomContextValue {
  chatRoomUuid: string;
  isMessaging: boolean;
}

const ChatRoomContext = createContext<ChatRoomContextValue>({
  chatRoomUuid: "main",
  isMessaging: false,
});

ChatRoomContext.displayName = "ChatRoomContext";

export interface ChatRoomContextProviderProps {
  chatRoomUuid: string;
  children: ReactNode;
  isMessaging?: boolean;
}

export const ChatRoomContextProvider = ({
  chatRoomUuid,
  isMessaging = false,
  children,
}: ChatRoomContextProviderProps) => (
  <ChatRoomContext.Provider value={{ chatRoomUuid, isMessaging }}>
    {children}
  </ChatRoomContext.Provider>
);

export const useChatRoomContext = () => useContext(ChatRoomContext);
